import { OnboardingDataStatus } from 'api/types/data';
import { OnboardingStatusType } from 'api/types/entity';
import { lodash } from 'helpers';

const onboardingStatusesForView: Record<OnboardingStatusType, boolean> = {
  [OnboardingStatusType.AwaitingPaymentConfirmation]: true,
  [OnboardingStatusType.ValidationCheck]: true,
  [OnboardingStatusType.ComplianceCheck]: true,
  [OnboardingStatusType.AmlCftCheck]: true,
  [OnboardingStatusType.BoardReview]: true,
  [OnboardingStatusType.AccountOpened]: false,
  [OnboardingStatusType.AccountOpening]: false,
  [OnboardingStatusType.AccountOpeningDenied]: false,
  [OnboardingStatusType.AwaitingAccountOpening]: false,
  [OnboardingStatusType.AwaitingValidation]: false,
  [OnboardingStatusType.FillingOut]: false,
  [OnboardingStatusType.SigningDocuments]: false,
  [OnboardingStatusType.AwaitingComplianceCheck]: false,
  [OnboardingStatusType.PendingBoardReview]: false,
  [OnboardingStatusType.AwaitingAmlCftCheck]: false,
  [OnboardingStatusType.SigningQuestionnaire]: false,
};

/**
 * Filters the onboarding statuses to include only those that should be visible.
 * If there are duplicate statuses, only the most recent one with a filled result is kept.
 */
export const filterVisibleOnboardingStatuses = (
  onboardingDataStatus: OnboardingDataStatus[] | undefined
): OnboardingDataStatus[] =>
  onboardingDataStatus
    ? lodash
        .sortBy(onboardingDataStatus, (v) => v.createdAt)
        .reduce((acc: OnboardingDataStatus[], statusData) => {
          const sameStatusInAccIdx = acc.findIndex(
            ({ value }) => value === statusData.value
          );

          if (onboardingStatusesForView[statusData.value]) {
            const hasResult = !!statusData.result?.length;

            if (
              sameStatusInAccIdx !== -1 &&
              acc[sameStatusInAccIdx].createdAt < statusData.createdAt &&
              hasResult
            ) {
              acc.splice(sameStatusInAccIdx, 1);
            }

            if (hasResult) {
              acc.push(statusData);
            }
          }

          return acc;
        }, [])
    : [];
